import React, { useContext, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AppStack from '../components/common/AppStack';
import AppFlexbox from '../components/common/AppFlexbox';
import StoreDashboardOverview from '../components/content/stores/StoreDashboardOverview';
import StoreReportsView from '../components/content/stores/StoreReportsView';
import StoreOrdersView from '../components/content/stores/StoreOrdersView';
import StoreProductsView from '../components/content/stores/StoreProductsView';
import StoreSidebar from '../components/content/navigation/StoreSidebar';
import WebstoreViews from '../components/content/webstore/WebstoreViews';
import StoreCollectionsView from '../components/content/stores/StoreCollectionsView';
import StoreSetupGuideSidebar from '../components/content/stores/StoreSetupGuideSidebar';
import { Context as AuthContext } from '../providers/AuthContextProvider';
import StoreFundraisingView from '../components/content/stores/StoreFundraisingView';
import StoreCustomersView from '../components/content/stores/StoreCustomersView';
import StoreAnalyticsView from '../components/content/stores/StoreAnalyticsView';
import StoreEscrowPaymentsView from '../components/content/stores/StoreEscrowPaymentsView';
import StoreGroupOrdersView from '../components/content/stores/StoreGroupOrdersView';
import NotificationsViews from '../components/content/notifications/NotificationsViews';
import StoreSettingsViews from '../components/content/stores/StoreSettingsViews';
import StoreAlertBanner from '../components/content/stores/StoreAlertBanner';
import StoreContentView from '../components/content/stores/StoreContentView';
import MerchantStoresView from '../components/content/stores/MerchantStoresView';
import StoreBundlesView from '../components/content/stores/StoreBundlesView';

const hiddenSidebarRoutes = [
  /\/merchant\/webstore\/themes\/(.*)\/(.*)/,
  /\/merchant\/stores\/switch/,
  /\/merchant\/reports\/result/,
  /\/merchant\/products\/discover/
];

const MerchantsView = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { state: authState } = useContext(AuthContext);
  const showSidebar = !hiddenSidebarRoutes.some((r) => pathname.match(r));
  const selectedStore = authState.ecomStores.find(
    (v) => v.pkEcomStore.toString() === authState.pkEcomStore?.toString()
  );

  useEffect(() => {
    if (
      authState.isAuthenticated &&
      !authState.loading &&
      authState.ecomStores.length === 0
    ) {
      navigate(`/merchant/stores/switch`);
    }
  }, [authState.isAuthenticated, authState.loading, pathname]);

  return (
    <AppFlexbox style={{ gap: 5, flex: 1 }}>
      {showSidebar && <StoreSidebar />}
      <AppStack style={{ flex: 1, width: '100%', overflow: 'hidden' }}>
        <Routes>
          <Route element={<MerchantStoresView />} path="/stores/*" />
          <Route element={<StoreProductsView />} path="/products/*" />
          <Route element={<StoreFundraisingView />} path="/fundraising/*" />
          <Route element={<StoreCollectionsView />} path="/collections/*" />
          <Route element={<StoreBundlesView />} path="/product-bundles/*" />
          <Route element={<StoreGroupOrdersView />} path="/group-orders/*" />
          <Route element={<StoreOrdersView />} path="/orders/*" />
          <Route element={<StoreCustomersView />} path="/customers/*" />
          <Route element={<StoreAnalyticsView />} path="/analytics/*" />
          <Route element={<StoreReportsView />} path="/reports/*" />
          <Route element={<NotificationsViews />} path="/notifications/*" />
          <Route element={<WebstoreViews />} path="/webstore/*" />
          <Route element={<StoreSettingsViews />} path="/settings/*" />
          <Route element={<StoreContentView />} path="/content/*" />
          <Route
            element={<StoreEscrowPaymentsView />}
            path="/escrow-payments/*"
          />
          <Route element={<StoreDashboardOverview />} path="/*" />
        </Routes>
      </AppStack>
      <StoreSetupGuideSidebar />
      <StoreAlertBanner ecomStore={selectedStore} />
    </AppFlexbox>
  );
};

export default MerchantsView;
